<template>
  <v-chip
    small
    outlined
    :color="statusMap('color')"
  >
    {{ statusMap('label') }}
  </v-chip>
</template>
<script>
import { get } from 'lodash'

export default {
  props: {
    payout: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    statusMap(key) {
      const { status } = this.payout || {}

      const statusMap = {
        paid: {
          color: 'success',
          label: 'Paid'
        },
        pending: {
          color: 'info',
          label: 'Pending'
        },
        in_transit: {
          color: 'info',
          label: 'In transit'
        },
        canceled: {
          color: 'error',
          label: 'Canceled'
        },
        failed: {
          color: 'error',
          label: 'Failed'
        }
      }

      return status in statusMap && key in statusMap[ status ]
        ? statusMap[ status ][ key ]
        : get(this.payout, 'status', '')
    }
  }
}
</script>
